import type { Params } from '@vimcar/mvvm/linkViewModel'
import type { Transitioner } from '#components/TransitionProvider'

import * as mobx from 'mobx'
import PT from 'prop-types'

export type ViewModel = {
  onBack: () => void
}

type Props = {
  onBack?: () => void
}

type Context = {
  transitioner: Transitioner
}

const mkViewModel = (
  params: Params,
  { onBack }: Props,
  { transitioner }: Context,
): ViewModel => {
  const vm = mobx.observable({
    handleBack: mobx.action(() => {
      if (onBack) onBack()
      transitioner.goBack()
    }),
  })
  // @ts-expect-error@2741
  return vm
}

mkViewModel.contextTypes = {
  transitioner: PT.object.isRequired,
}

export default mkViewModel
